import styled from 'styled-components';

const StyledLinkGeneration = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  min-height: ${prop => (prop.isMobile ? 50 : 65)}px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  .generate-link {
    width: ${props => (!props.isMobile ? '100%' : 'auto')};
    font-family: 'Consolas', sans-serif;
    font-weight: 600;
    font-size: ${props => (!props.isMobile ? 28 : 24)}px;
    text-decoration: underline;
    text-align: center;
    outline :none;
    background-color: transparent;
    color: #555;
    border: none;
    cursor: pointer;
    &:hover {
      color: #434343;
    }
    &:focus {
      outline :none;
    }
    &.loading {
      font-size: ${props => (!props.isMobile ? 11 : 16)}px;
      font-weight: ${props => (!props.isMobile ? 400 : 600)}px;
      text-decoration: none;
      color: #${props => (!props.isMobile ? 999 : 707070)};
      cursor: default;
    }
  }
  .generating-link {
    margin-bottom: 0;
    width: ${props => (!props.isMobile ? '100%' : 'auto')};
    font-family: 'Consolas', sans-serif;
    font-size: ${props => (!props.isMobile ? 11 : 16)}px;
    font-weight: ${props => (!props.isMobile ? 400 : 600)}px;
    text-align: center;
    color: #555;
  }
  .loading {
    svg {
      width: 45px;
      height: 45px;
    }
  }
  .generated-links {
    display: flex;
    padding: ${props => (props.isMobile ? '0 10px 15px' : '0 20px')};
    width: 100%;
    
    margin: 10px 0;
    align-items: center;
    justify-content: ${props => (!props.isMobile ? 'none' : 'space-between')};
    &-title {
      margin: 0;
      font-size: ${props => (props.isMobile ? '16px' : '18px')};
      font-weight: 600;
      font-family: 'Consolas', sans-serif;
      white-space: nowrap;
      color: #555;
    }
    &-list {
      display: flex;
      margin:${props => (!props.isMobile ? '0 20px 0 20px' : '0 5px')};
      flex: 0 0 ${props => (!props.isMobile ? 130 : 120)}px;
      justify-content: space-between;
    }
    .link {
      display: flex;
      transition: 0.3s ease-out;
      padding: 0;
      width: 30px;
      height: 30px;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: none;
      cursor: pointer;
      &:hover {
        box-shadow: 0 3px 3px 1px rgba(0,0,0,0.4);
      }
      &:focus {
        outline: none;
      }
      img {
        max-width: 18px;
        max-height: 18px;
      }
      &.facebook {
        background-color: #3B5998;
      }
      &.twitter {
        background-color: #1DA1F2;
      }
      &.telegram {
        background-color: #0088CC;
      }
    }
    .copy-link {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      text-decoration: underline;
      white-space: nowrap;
      color: #707070;
      &:hover {
        color: #555555;
      }
      img {
        margin-right: 4px;
        width: 16px;
      }
      
      &.desktop {
        width: 30px;
        height: 30px;
        background-color: #148462;
        border-radius: 25px;
        
        img {
          position: relative;
          top: 4px;
          left: 2px;
       } 
      }
    }
    
    &.with-divider {
      border-bottom: 1px solid #CCCCCC;
      margin: 10px 20px 0 20px;
      padding: ${props => (props.isMobile ? '0 10px 15px' : '0 0 20px 0')};
    }
  }
  .share-mobile {
    display: flex;
    position: relative;
    margin: 0 20px;
    width: 30px;
    height: 30px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    background-color: #17936F;
    border: none;
    img {
      max-width: 16px;
      height: 100%;
    }
  }
  .notification {
    display: flex;
    margin: 10px 20px 10px;
    width: 100%;
    align-items: flex-start;
    justify-content: center;
    img {
      margin: 3px 9px 0 0;
      height: 15px;
    }
    span {
      text-align: center;
      font-size: ${props => (!props.isMobile ? 14 : 15)}px;
      font-weight: 500;
      color: #17936F;
    }
  }
  
  @-moz-document url-prefix() {
    .generated-links-list {
      margin:${props => (!props.isMobile ? '0 17px 0 18px' : '0 5px')};
    }
    
    .generated-links-title {
      font-size: 17px;
    }
  }
`;

export default StyledLinkGeneration;
